<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            :class='[{fixed: innerBlockPosition === "fixed"}, {bottom: innerBlockPosition === "bottom"}]'
            )
            .animated-scroll__walking(v-if='rows' :class='`${name}`')
                .animated-scroll__row(
                    v-for='(row, rowIndex) in +rows', 
                    :class='name' 
                    :ref='[(row%2==0) ? `even` : `odd`]',
                    :key='rowIndex'
                    )
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

export default {
    props: {
        rows: {
            type: String
        },
        name: String,
        settings: Object,
        isActive: Boolean
    },

    data() {
        return {
            stopEvent: false,
            innerBlockPosition: '',
            isControlScroll: true
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .fromTo(this.$refs.even, {x: '-50%'}, {duration: 3, x: '0%', ease: 'none'}, '0')
                .fromTo(this.$refs.odd, {x: '0'}, {duration: 3, x: '-50%', ease: 'none'}, '0');
            this.timeline.progress(0.0001);
        },
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'bottom-top');
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 100vh;
    // height: calc(var(--vh) * 300);
    position: relative;
    overflow: hidden;

    // @media screen and (--viewport-tablet) {
    //     height: 150vh;
    //     height: calc(var(--vh) * 150);
    // }
}
.white {
    .animated-scroll {
        &__walking:not(.sholves) {
            margin-bottom: 80px;
            @media (--viewport-laptop) {
                margin-bottom: 30px;
            }
        }
    }
}
.animated-scroll {
    position: static !important;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;

    &__walking {
        width: 200vw;
        height: 100vh;
        //margin-bottom: 80px;
        // height: calc(var(--vh) * 100);

        &.sticks,
        &.guns,
        &.bullets,
        &.sholves {
            display: flex;
            flex-direction: column;
            justify-content: center;
            background-color: #000;
        }
    }

    &.fixed {
        position: fixed;
        top: 0;
        left: 0;
    }

    &.bottom {
        bottom: 0;
        top: auto;
    }
    &__row {
        &.sticks {
            background-image: url('../../assets/img/animated-scroll/stick.svg'), url('../../assets/img/animated-scroll/stick.svg');
            background-origin: content-box;
            background-repeat: repeat-x;
            padding: 2.75vh 0;
            height: 20%;
            background-size: 12.5vh auto;
            background-position: 0, 6.25vh;
        }

        &.sholves {
            background-image: url('../../assets/img/animated-scroll/sholves.svg');
            background-origin: content-box;
            background-repeat: repeat-x;
            padding: 2.75vh 0;
            height: 20%;
            background-size: auto 97%;
            background-position: 0;
        }

        &.guns {
            background-origin: content-box;
            background-repeat: repeat-x;
            background-position: 0 center;
            padding: 2.75vh 0;
            height: 20%;

            &:nth-child(1) {
                background-image: url('../../assets/img/animated-scroll/kalash.svg');
                background-size: 25vw auto;
            }
            &:nth-child(2) {
                background-image: url('../../assets/img/animated-scroll/grenade.svg');
                background-size: 65px auto;
            }
            &:nth-child(3) {
                background-image: url('../../assets/img/animated-scroll/rifle.svg');
                background-size: 25vw auto;
                background-position: center;
            }
            &:nth-child(4) {
                background-image: url('../../assets/img/animated-scroll/smoke-grenade.svg');
                background-size: 70px auto;
            }
            &:nth-child(5) {
                background-image: url('../../assets/img/animated-scroll/pistol.svg');
                background-size: 155px auto;
            }
        }

        &.bullets {
            background-origin: content-box;
            background-repeat: repeat-x;
            background-position: 0 center;
            padding: 2.75vh 0;
            height: 20%;

            &:nth-child(2n + 1) {
                background-image: url('../../assets/img/animated-scroll/bullet-big.svg');
                background-size: 25vw auto;
            }
            &:nth-child(2n) {
                background-image: url('../../assets/img/animated-scroll/bullet-small.svg');
                background-size: 12.5vw auto;
            }
        }
    }
}

// .masked-text {
//     height: auto;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: flex-start;
//     padding: 40px 0;

//     &__mask {
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//     }

//     .content {
//         &_glass {
//             background-color: #000;
//             color: #fff;
//         }
//         &_aim {
//             background-color: #fff;
//             color: #000;
//             &.blur {
//                 filter: blur(2px);
//             }
//         }
//     }
// }

// .mask-aim {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100vh;
//     // height: calc(var(--vh) * 100);
//     pointer-events: none;

//     &__blur {
//         background-color: #fff;
//         opacity: 0.5;
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//     }

//     &__circle {
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//     }
// }

// #glassGap {
//     transform-origin: center center;
//     transform: scale(0);
// }
</style>
